module.exports = __webpack_public_path__ + "static/img/elixir-belgium-logo_Aug2020.fb645570.png";